// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"HostLocations_wrapper__2eU2J","contentWrapper":"HostLocations_contentWrapper__TkO-8","header":"HostLocations_header__387P6","content":"HostLocations_content__1KFq9"};